import script from "./CreateSip.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSip.vue?vue&type=script&setup=true&lang=js"

import "./CreateSip.vue?vue&type=style&index=0&id=425090ee&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-425090ee"]])

export default __exports__